// @flow
import React, { type Node } from 'react';
import './BanneringTemplate.scss';

type Props = {
  children: Node,
};

const BanneringTemplate = ({ children }: Props) => (
  <div className="BanneringTemplate">{children}</div>
);

export default BanneringTemplate;



// WEBPACK FOOTER //
// ./src/components/bannering/BanneringTemplate/BanneringTemplate.js